import React from 'react'
import { ProfessionalViewModel } from './ProfessionalViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button, Modal } from 'react-bootstrap';
import fechar from '../../Imagens/close-24.png'; 
import salvar from '../../Imagens/save-16.png'; 

import "../../Estilo/Form.css";
import Select from 'react-select';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { InputModalSelectComponent } from '../../Components/InputModalSelectComponent';
import { PersonViewModel } from '../Person/PersonViewModel';
import { PersonViewController, PersonViewControllerDelegate } from '../Person/PersonViewController';

interface MyProps {
    navigation: any
    delegate: ProfessionalViewControllerDelegate
    viewModel: ProfessionalViewModel
    idPrimary: number
}

export interface ProfessionalViewControllerDelegate {
    tapDimiss(navigation: any): void
}

export class ProfessionalViewController extends React.Component<MyProps> implements PersonViewControllerDelegate {

    private formEvent: FormEvent
    state = {
        isLoading: false,
        json: {},
        person: Array<any>(),
        users: Array<any>(),
        showAddPerson: false
    }

	constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }
    
    tapDimiss(navigation: any): void {
        this.setState({
            showAddPerson: false
        })
    }

    componentDidMount() {
        this.loadUser()
        if(this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation}/>
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Profissional</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                    onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                    src={fechar}/>
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                    id="sgepusuariocargo"
                                    defaultValue={json['sgepusuariocargo'] ? json['sgepusuariocargo'] : ''}
                                    onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <Form.Label className="isRequired">Usuário</Form.Label>
                                    <Select
                                    id="cusuario"
                                    value={this.formEvent.onValueSelect('select', 'cusuario', this.state.users)}
                                    onChange={(e: any) => this.formEvent.onChange("select", e, "cusuario")}
                                    closeMenuOnSelect={true}
                                    placeholder={"Selecione"}
                                    options={this.state.users}
                                    isMulti={false}
                                    />
                                </Col>
                                <Col lg="4" xs="12" className="bottom10">
                                    <InputModalSelectComponent 
                                    id="sgeppessoa"
                                    keyValue="nome"
                                    label="Pessoa"
                                    required={true}
                                    placeholder="Procure"
                                    showAddButton={true}
                                    navigation={this.props.navigation}
                                    titleModal="Pessoas"
                                    table="geppessoas"
                                    valueDefault={json['nome']}
                                    getValue={(id: number, value: string) => this.setIdPerson(id, value)}
                                    tapAdd={() => this.setState({showAddPerson: true})} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{marginTop: 20}}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                        src={salvar}/>
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                {this.getModalAddPerson()}
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({isLoading: this.state.isLoading})}/>
            </div>
        )
    }

    private setIdPerson(id: number, value: string) {
        var json = this.state.json as any 
        json['sgeppessoa'] = id 

        this.setState({
            json: json
        })
    }

    private getModalAddPerson() {
        let viewModel = new PersonViewModel()
        return (
            <Modal show={this.state.showAddPerson} dialogClassName="modal-full-screen">
                <Modal.Body>
                    <PersonViewController
                    navigation={this.props.navigation} 
                    delegate={this} 
                    idPrimary={0} 
                    viewModel={viewModel}
                    isShowHeader={false}
                    />
                </Modal.Body>
            </Modal>
        )
    }

    private loadUser() {
        this.props.viewModel.fetchUser().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for(var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({value: item.id, label: item.value, check: false})
            }

            this.setState({
                users: array
            })
        });
    }

    private save() {
        var json = this.state.json as any
        if(json["cusuario"] == undefined && json["sgeppessoa"] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                this.props.delegate.tapDimiss(this.props.navigation);
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    private loadStruct() {
        var json = this.state.json as any 
        json['sgepusuariocargo'] = this.props.idPrimary

        this.setState({isLoading: true})
        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if(resultado.length > 0) {
                this.setState({
                    isLoading: false,
                    json: resultado[0]
                })

                return
            }

            this.setState({isLoading: false})
        },e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
}